import $ from "jquery";

$(function () {
    $(document).on('click', '.form-input-password__button', function () {
        const inputPassword = $(this).closest('.form-input-password__inner').find('.form-input-password__input');
        let isOpening = inputPassword.attr('type') === 'password';

        if (isOpening) {
            inputPassword.attr('type', 'text');
            $(this).addClass('form-input-password__button--open');
        } else {
            inputPassword.attr('type', 'password');
            $(this).removeClass('form-input-password__button--open');
        }
    });
});
